$('.feature-slide').slick({
    dots: false,
    infinite: true,
    speed: 600,
    arrows: true,
    slidesToShow: 4,
    centerPadding: '20px',

    autoplay: false,
    autoplaySpeed: 2000,
    slidesToScroll: 1,
    prevArrow: '<button type="button" class="slick-prev">Previous</button>',
    nextArrow: '<button type="button" class="slick-next">Next</button>',
    responsive: [{
            breakpoint: 1370,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
                infinite: true,
                dots: false
            }
        }, {
            breakpoint: 1230,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true,
                dots: false
            }
        }, {
            breakpoint: 992,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
                dots: false
            }
        },
        {
            breakpoint: 769,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
    ]
});


$('.client-reviews').slick({
    dots: false,
    infinite: true,
    speed: 600,
    arrows: true,
    slidesToShow: 3,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToScroll: 1,
    prevArrow: '<button type="button" class="slick-prev">Previous</button>',
    nextArrow: '<button type="button" class="slick-next">Next</button>',
    responsive: [{
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
                dots: false
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
    ]
});

$('.slider-graphice-new').slick({
    dots: true,
    infinite: true,
    speed: 600,
    arrows: true,
    slidesToShow: 3,
    autoplay: false,
    autoplaySpeed: 2000,
    slidesToScroll: 1,
    prevArrow: '<button type="button" class="slick-prev">Previous</button>',
    nextArrow: '<button type="button" class="slick-next">Next</button>',
    responsive: [{
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
                dots: false
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
    ]
});
$('.bud-photo').slick({
    dots: false,
    infinite: true,
    speed: 600,
    arrows: true,
    slidesToShow: 3,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '60px',
    prevArrow: '<button type="button" class="slick-prev">Previous</button>',
    nextArrow: '<button type="button" class="slick-next">Next</button>',
    responsive: [{
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
                dots: false
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
    ]
});




$('.pro-slider-mini').slick({
    dots: false,
    infinite: true,
    speed: 600,
    arrows: true,
    slidesToShow: 2,
    autoplay: false,
    autoplaySpeed: 2000,
    slidesToScroll: 2,
    centerMode: true,
    centerPadding: '0px',
    prevArrow: '<button type="button" class="slick-prev">Previous</button>',
    nextArrow: '<button type="button" class="slick-next">Next</button>',
    responsive: [{
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                infinite: true,
                dots: false
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
    ]
});

$('.pro-slider').slick({
    dots: false,
    infinite: true,
    speed: 600,
    arrows: true,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '0px',
    prevArrow: '<button type="button" class="slick-prev">Previous</button>',
    nextArrow: '<button type="button" class="slick-next">Next</button>',
    responsive: [{
            breakpoint: 1024,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: false
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
    ]
});


$('.js-anchor-link').click(function(e){
  e.preventDefault();
  var target = $($(this).attr('href'));
  if(target.length){
    var scrollTo = target.offset().top;
    $('body, html').animate({scrollTop: scrollTo+'px'}, 800);
  }
});
  		





function openNav() {
    document.getElementById("mySidenav").style.width = "340px";
}

function closeNav() {
    document.getElementById("mySidenav").style.width = "0";
};







$('.toggle').click(function(e) {
    $(this).next('.dropdown-menu ').slideToggle(500);
    $(this).parent('li').siblings().children('.dropdown-menu').slideUp(500);
    
    });
    
    $('.togglex').click(function(e) {
        $(this).next('.dropdown-menux ').slideToggle(500);
        $(this).parent('li').siblings().children('.dropdown-menux').slideUp(500);
        
        $('a.activex').removeClass('activex');
        
        $(this).addClass("activex")
        });
    
    
    $('.home-main-tv').click( function() {
        $(".home-main-tv").removeClass("p-video");
    } );
    
    $('.play-vid').click( function() {
        $(".pause-vid").toggleClass("trex-play");
    } );
    
    $('.pause-vid').click( function() {
        $(".play-vid").toggleClass("trex-pause");
    } );
    
    
    
    
    
    
    
    
    
    $('.play-vid').click(function(){
        var $this = $(this);
        var id = $this.attr('id').replace(/btn/, '');
        $this.toggleClass('active');
        if($this.hasClass('active')){
            $this.text('pause'); 
             $('.youtube-video')[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');     
        } else {
            $this.text('play');
           $('.youtube-video')[0].contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
        }
    });